import TabbedPaymentMethods from './TabbedPaymentMethods'

export default TabbedPaymentMethods
